<app-page-header title="Home" active_item="Aprovar saques"></app-page-header>
<div class="loading-approve" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>Aprovar saques</h5>
<div class="row">
  <div class="col-12">
    <div class="card rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Saques</div>
        <div class="card-options">
          <button
            type="button"
            class="our-button btn btn-pill btn-danger float-end"
            (click)="approve(false)"
          >
            <i class="fe fe-x"></i>Reprovar
          </button>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="approve(true)"
          >
            <i class="fe fe-check"></i>Aprovar
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="scrollable-layout">
          <div class="table-responsive our-table">
            <table class="table table-striped text-nowrap mb-0">
              <thead class="border-top">
                <tr>
                  <th class="align-middle text-center" scope="col">
                    Selecionar
                  </th>
                  <th class="align-middle text-center" scope="col">Data</th>
                  <th scope="col">Identificador</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Pix</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Status</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom" *ngFor="let data of tableData">
                  <td class="align-middle text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        [(ngModel)]="data.selected"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <span>{{
                      data.date | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                    }}</span>
                  </td>
                  <td>
                    <span>{{ data.id }}</span>
                  </td>
                  <td>
                    <span>{{ data.name }}</span>
                  </td>
                  <td>
                    <span class="truncate">{{ data.pixKey }}</span>
                  </td>
                  <td>
                    <span>{{ data.pixType }}</span>
                  </td>
                  <td>
                    <span>{{ data.status }}</span>
                  </td>
                  <td>
                    <span>R$ {{
                      data.valor
                        | mask
                          : "separator.2"
                          : { decimalMarker: ",", leadZero: true }
                    }}</span>
                  </td>
                </tr>
                <tr *ngIf="tableData.length == 0">
                  <td colspan="8">Não contém dados</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp(); getPendingWithdraw()"
      />
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp(); getPendingWithdraw()"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
